module.exports = __webpack_public_path__ + "img/thumbnail_ReticulatedGiraffe_m_normal.a13f23f8.png";